import type { Page, PartFittingView, PartIntervalListQuery, PartReplacementIntervalView, PartsRegisterListQuery, TruckPartsListQuery } from '@chukua/common';
import { api } from '../../../../shared/shared.api';
import { toListParams } from '../../../../shared/policies/list-params';

export type { PartFittingView, PartReplacementIntervalView };

export function listPartsRegister(query: PartsRegisterListQuery): Promise<Page<PartFittingView>> {
  return api<Page<PartFittingView>>(`/parts-register?${toListParams(query)}`);
}

export function listTruckParts(truckId: string, query: TruckPartsListQuery): Promise<Page<PartFittingView>> {
  return api<Page<PartFittingView>>(`/trucks/${truckId}/parts?${toListParams(query)}`);
}

export function listTruckPartIntervals(truckId: string, query: PartIntervalListQuery): Promise<Page<PartReplacementIntervalView>> {
  return api<Page<PartReplacementIntervalView>>(`/trucks/${truckId}/part-intervals?${toListParams(query)}`);
}
